import { Component, Input, OnInit, inject } from '@angular/core';
import { AppConstants } from 'src/app/app-constants';
import { IComplianceFact } from 'src/app/interfaces/icompliance-fact';
import { IComplianceSampleQuote } from 'src/app/interfaces/icompliance-sample-quote';
import { IComplianceSampleQuoteParts } from 'src/app/interfaces/icompliance-sample-quote-parts';
import { IComplianceScoring } from 'src/app/interfaces/icompliance-scoring';
import { FeatureFlagsService } from 'src/app/services/feature-flags.service';
import { splitSampleQuote } from 'src/app/utils/compliance-sample-quote.util';

/** Out-of-compliance box shared by every results page: the guidelines the learner missed. */
@Component({
  selector: 'app-compliance-missed-guidelines',
  standalone: false,
  templateUrl: './compliance-missed-guidelines.component.html',
  styleUrls: ['./compliance-missed-guidelines.component.scss'],
})
export class ComplianceMissedGuidelinesComponent implements OnInit {
  @Input() complianceScoringResult: IComplianceScoring | null | undefined;
  /** The "Compliance only" setting: the copy says the learner was out of compliance and got no score. */
  @Input() complianceOnly = false;

  private featureFlagsService = inject(FeatureFlagsService);
  showSampleQuote = false;

  // Re-read from Split each time: the flag must hide the quote as soon as it's turned off, not after a reload.
  async ngOnInit(): Promise<void> {
    this.showSampleQuote = await this.featureFlagsService.refreshFlag(AppConstants.COMPLIANCE_SAMPLE_QUOTE);
  }

  /** Guidelines the learner missed (correct === 0), from every section. */
  get missedFacts(): IComplianceFact[] {
    return (this.complianceScoringResult?.sections ?? []).flatMap((section) => section.facts).filter((fact) => fact.correct === 0);
  }

  quoteParts(quote: IComplianceSampleQuote): IComplianceSampleQuoteParts {
    return splitSampleQuote(quote);
  }
}
